import { Api } from '@/interface/api';

/**
 * 查询地址
 */
const shippingAddressQuery: Api = {
    url: '/api/project/proxy-token/api/shipping-address/query',
    method: 'get',
};

/**
 * 编辑地址
 */
const shippingAddressUpdate: Api = {
    url: '/api/project/proxy-token/api/shipping-address/update',
    method: 'post',
};

export {
    shippingAddressQuery,
    shippingAddressUpdate,
};
